module.exports = __webpack_public_path__ + "static/media/Badkonzepte_2.678cc033.jpg";